import React from 'react';
import { TeamBonusMode } from '../../store/types';

interface TeamBonusModeToggleProps {
    mode: TeamBonusMode;
    onChange: (mode: TeamBonusMode) => void;
    className?: string;
}

/** Synchroner Umschalter Einzel-Bonus | Team-Bonus (pe-* + Amber-Aktiv). */
export const TeamBonusModeToggle: React.FC<TeamBonusModeToggleProps> = ({
    mode,
    onChange,
    className = '',
}) => {
    const btn = (value: TeamBonusMode, label: string) => {
        const active = mode === value;
        const isTeam = value === 'team';
        return (
            <button
                type="button"
                onClick={() => onChange(value)}
                className={`px-4 py-2 text-[10px] font-black uppercase tracking-widest rounded-lg border transition-all ${
                    active
                        ? isTeam
                            ? 'bg-amber-500 text-black border-amber-400 shadow-[0_0_16px_rgba(245,158,11,0.35)]'
                            : 'bg-[#E6C299] text-black border-[#E6C299] shadow-lg'
                        : 'bg-pe-tile-header dark:bg-[#15171e] text-pe-muted dark:text-slate-400 border-pe-border dark:border-slate-700 hover:border-pe-border-strong'
                }`}
            >
                {label}
            </button>
        );
    };

    return (
        <div className={`inline-flex items-center gap-2 ${className}`} role="group" aria-label="Bonus-Modus">
            {btn('individual', 'Einzel-Bonus')}
            {btn('team', 'Team-Bonus')}
        </div>
    );
};

export default TeamBonusModeToggle;
